module.exports = __webpack_public_path__ + "img/adhka-yx1zn.018.9ae425b1.jpeg";